import { Box, Grid, Typography, Tab, Button, IconButton } from '@mui/material'
import Loader from '../../../../../../components/loader'
import { BreadCrumb, CustomTable, SnackSimple } from '../../../../../../components'
import { LoadingButton, TabContext, TabList, TabPanel } from '@mui/lab'
import { CustomPaper } from '../../../../../../components/CustomPaper'
import SimpleModal from '../../../../../../components/modal/simpleModal'
import { useTranslation } from 'react-i18next'
import { useContextState } from '../../../../../../hooks/theme'
import { useStyles } from './styles'
import { AddUsers } from './components/addUsers'
import { DinamicForm } from '../../../../../../components/dinamicForm'
import { useBody } from './hooks/body'
import { FiltersDrawer } from '../../../../../../components/filtersDrawer'
import { icons } from '../../../../../../utils/icons'
import { useParams } from 'react-router-dom'


const PermissionGroup = () => {
    const { id } = useParams()
    const body = useBody({id})
    const { t } = useTranslation()
    const { colors } = useContextState()
    const styles = useStyles()


    return (
        <Box sx={styles.container}>
            <BreadCrumb removeBreadcrumb={['user']} />


            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                {
                    body.tabValue == '2' && (
                        <Grid container columnSpacing={1} alignItems="center">
                            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} sx={{ position: 'relative' }}>
                                <FiltersDrawer m={{ mt: 2 }} cleanFilter={body.filter.cleanFilter} count={body.filter.counter} right={-50} top={0}>
                                    <Box>
                                        <DinamicForm input={Object.values(body.input ?? {})} values={body.filter.filterData ?? {}} onChange={body.filter.onChange} filter={true} legacyErrors />
                                    </Box>
                                </FiltersDrawer>
                            </Grid>
                        </Grid>
                    )
                }

                <TabContext value={body.tabValue}>
                    <Box sx={styles.containerTabList}>
                        <Box>
                            <Typography fontWeight={'bold'} fontSize={20}>{t('userGroup.titles.permissionAsignement')}</Typography>
                        </Box>

                        <TabList onChange={body.handleChange} sx={styles.tabList} aria-label="lab API tabs example">
                            {body.tabValue == '2' && (body.filter.counter ?? 0) > 0 && <IconButton onClick={body.filter.cleanFilter}>{icons('clean')}</IconButton>}
                            <Tab label={t('Questionarie.permissions.addUsers')} value="1" />
                            <Tab label={
                                <Box sx={styles.tab2}>
                                    <Typography>{t('Questionarie.permissions.assigningPermissions')}</Typography>
                                    {
                                        body.tabValue == '2' && (
                                            <LoadingButton
                                                loading={!!body.loadings?.submit}
                                                variant="contained"
                                                disabled={!body.rowAdded.length}
                                                onClick={() => {
                                                    body.submit()
                                                }}
                                            >
                                                {t(`general.save`)}
                                            </LoadingButton>
                                        )
                                    }
                                </Box>
                            } value="2" />
                        </TabList>
                    </Box>

                    <TabPanel sx={styles.tabContext} value="1">
                        <AddUsers
                            cleanFilter={() => { body.createFilter.cleanFilter() }}
                            close={body.cancelSearchUsers}
                            rigthItem={<DinamicForm input={Object.values(body.inputCreate ?? {})} onChange={body.createFilter.onChange} errors={body.createFilter.errors} values={body.createFilter.filterData} />}
                            searchButton={{
                                disabled: !body.createFilter.query?.filter,
                                loading: !!body.loadings.search,
                                onClick: body.searchUsers
                            }}
                            row={body.rowAdd}
                            usersAlreadyAdded={body.rowAddedFiltered.map(item => item.id)}
                            handleAddUsers={body.handleAddUsers}
                        />
                    </TabPanel>

                    <TabPanel sx={styles.tabContext} value="2">
                        <CustomPaper elevation={2} sx={{ padding: 3 }}>
                            <Box sx={styles.headerSecondTab}>
                                <Box>
                                    <Typography sx={styles.userAmount}>{body.rowAdded?.length} {t('Questionarie.permissions.users')}</Typography>
                                    <Typography sx={styles.questionnaireAccess}>{t('userGroup.titles.groupAcces')}</Typography>
                                </Box>
                                <Box>
                                    {
                                        !!body.listDeleteUsers?.some(item => !!item) && (
                                            <Button
                                                sx={styles.delete}
                                                onClick={() => {
                                                    body.handleDelete()
                                                }}
                                            >
                                                {t('general.deleteSelectedUsers')}
                                            </Button>
                                        )
                                    }
                                </Box>
                            </Box>

                            <CustomTable
                                ref={body.refTable}
                                name="Informe General"
                                dontRefresh
                                column={body.columns.columnMain}
                                row={body.rowAddedFiltered}
                                selected={-1}
                                loader={body?.loadings.main}
                            />
                        </CustomPaper>
                    </TabPanel>
                </TabContext>
            </Grid>

            <SnackSimple close={body.closeSnackbar} open={body.snackbar.open} type={body.snackbar.type} message={body.snackbar.message} />

            <SimpleModal
                open={!!body.openModal?.open}
                close={() => { if (body.openModal?.cancel) { body.openModal?.cancel() } }}
                title={body.openModal?.title ?? ""}
                description={body.openModal?.description ?? ""}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                color={colors}
                back={() => { if (body.openModal?.cancel) { body.openModal?.cancel() } }}
                loadingButton
                next={() => { if (body.openModal?.confirm) { body.openModal?.confirm() } }}
            />
        </Box>
    )
}

export default PermissionGroup
